/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});

try {
$(body).on('afterAddItem.ajaxCart', function(e, lineItem) {
  fbq('track', 'AddToCart', {
    content_ids: [lineItem.id],
    content_type: lineItem.product_type,
    content_name: lineItem.title,
    currency: Shopify.currency.active, 
    value: lineItem.final_price / 100
  });
})

waitForElm('[name="checkout"]').then((elm) => {
  $('.js-cart-checkout-validate').on("submit", function() {
    ShopifyAPI.getCart((cart) => {
      fbq('track', 'InitiateCheckout', {
        content_ids: cart.items.map(item => item.id),
        currency: Shopify.currency.active,
        value: cart.total_price,
        items: cart.items.map(item => {
          return {
            id: item.id,
            name: item.title,
            quantity: item.quantity
          }
        })
      });
    })
  })
})


function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
  
} catch (error) {
  console.log(error)
}

const productFormATC = document.querySelector(".product-single__bottom .js-product-buttons");

document.addEventListener("venue:variant:update", function(e) {
  const stickyBar = document.querySelector("[data-sticky-atc]");

  if (e.detail.variant) {
    stickyBar.querySelector("button").removeAttribute("disabled")
    stickyBar.querySelector("input").value = e.detail.variant.id;
    stickyBar.querySelector(".product-price").innerText = Shopify.formatMoney(e.detail.variant.price, theme.money_format);
  }
  else {
    stickyBar.querySelector("button").setAttribute("disabled", "")
  }
})

window.addEventListener('scroll', function() {
  var stickyBar = document.querySelector('[data-sticky-atc]');
  const elementTop = productFormATC.getBoundingClientRect().y;
  stickyBar.classList.toggle('show', elementTop < 0);
});


//Accordion JS
document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', function() {
            // Toggle the active state
            const expanded = header.getAttribute('aria-expanded') === 'true';

            // Close all accordion items
            document.querySelectorAll('.accordion-header').forEach(h => {
                h.setAttribute('aria-expanded', 'false');
                h.nextElementSibling.style.maxHeight = null;
            });

            // Toggle the clicked item
            if (!expanded) {
                header.setAttribute('aria-expanded', 'true');
                const content = header.nextElementSibling;
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
});